export const CR = 'Enter'; //Carriage Return